<template>
    <div class="control-panel">

        <ControlPanelSidebar />

        <div class="content col-8" style="padding-bottom: 2em;">
            <div class="logout" v-if="showLogout">
                Ingelogd als <span v-if="teamIndex >= 0">{{ teamDisplayName }}</span>
                &nbsp;
                |
                &nbsp;
                <a href="#" @click.prevent="logout">Uitloggen</a>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>
  
<script>
import { mapActions } from 'vuex';
import ControlPanelSidebar from '@/components/controlpanel/ControlPanelSidebar.vue';
// import gametree from "@/repository/gametree";
import textutils from '@/utils/textutils.js';

export default {
    name: 'ControlPanelView',
    components: { ControlPanelSidebar },
    computed: {
        showLogout() {
            return true; //gametree.isLogoutVisible(this.$store.state.session.variant, this.$store.state.session.progress);
        },
        teamIndex() {
            return this.$store.state.team;
        },
        teamDisplayName() {
            return textutils.teamName(this.$store.state.team);
        },
    },
    methods: {
        ...mapActions(['logoutUser']),
        logout() {
            if (window.confirm('Weet u zeker dat u wilt uitloggen?')) {
                this.logoutUser();
                this.$router.push('/');
            }
        }
    }
}
</script>
  
<style>
.control-panel {
    display: flex;
}
.logout {
    font-size: 12pt;
    font-weight: 600;
    padding: 0.5em;
    width: 100%;
    text-align: end;
}
.logout span, 
.logout a {
    font-size: 12pt;
    color: #5f8bff;
}
</style>
